import { render, staticRenderFns } from "./ListadoAbonosComponent.vue?vue&type=template&id=060c354a&scoped=true"
import script from "./ListadoAbonosComponent.vue?vue&type=script&lang=js"
export * from "./ListadoAbonosComponent.vue?vue&type=script&lang=js"
import style0 from "./ListadoAbonosComponent.vue?vue&type=style&index=0&id=060c354a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c354a",
  null
  
)

export default component.exports